import script from "./DataCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./DataCounter.vue?vue&type=script&setup=true&lang=js"

import "./DataCounter.vue?vue&type=style&index=0&id=5301c357&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5301c357"]])

export default __exports__